const vue_helpers = {
    methods: {
        obj_to_null(someObject){
            if(someObject == null ) {
                return null;
            }

            let res = Object.keys(someObject).length;

            if(res === 0) {
                return null;
            }
            return someObject;
        },



        toCurrency (value) {

            let user = {
                'currency' : {
                    'suffix' : "₴"
                }
            };

            try {
                user = v_store.getters['user/getUser'];
            }
            catch (e) {
                console.log(e);
            }

            let currency = " " + user.currency.suffix;


            if (typeof value !== "number") {
                value = parseFloat(value);
            }

            let formatter = new Intl.NumberFormat('ru-Ru', {
                // style: 'currency',
                //  currency: 'UAH',
                minimumFractionDigits: decimal_size
            });

            return formatter.format(value).replace(".",'') + currency;
        }
    }
}

export default vue_helpers;
